const restlog = () => {
    return {
        uid:null,
        process:'',
        decription:'',
        status:false,
        messages:[],
    }
}
export default restlog;